import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const reportsApi = createApi({
  reducerPath: "reports",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    runReport: builder.mutation({
      query: (data) => apiFunction(data, "/api/admin/reports/run", "POST"),
    }),
  }),
});

export const { useRunReportMutation } = reportsApi;
